
const Recommendations = () => {
    return (
        <div className="recommendations">
            <img className="rec" src="./images/rec1.png"/>
            <img className="rec" src="./images/rec2.png"/>
        </div>
    )
}

export default Recommendations